var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mx-auto",staticStyle:{"max-width":"750px","margin-top":"50px"}},[_c('p_agent',{attrs:{"pd":this.siteConf.Link}}),(_vm.loadFlag)?_c('div',{staticClass:"loading"},[_vm._v("Loading…")]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }